/* eslint-disable import/prefer-default-export */
export const confirmError = 'Hubo un problema al confirmar el usuario';
export const getAttributesError = 'Hubo un problema al obtener el usuario';
